import React from 'react';
import '../LegalPages.css';
import Footer from '../../../components/layout/Footer/Footer';
import Header from '../../../components/layout/Header/Header';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <div className="legal-page">
      <div className="classjustforheadercolor"></div>
      <Header />
      
      {/* Hero Section */}
      <section className="legal-hero">
        <div className="container">
          <div className="legal-hero__content">
            <div className="hero-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
              </svg>
              <span>Conditions Générales</span>
            </div>
            
            <h1 className="legal-hero__title">
              Conditions Générales <span className="title-highlight">d'Utilisation</span>
            </h1>
            
            <p className="legal-hero__subtitle">
              Veuillez lire attentivement ces conditions avant d'utiliser nos services.
            </p>
            
            <div className="legal-meta">
              <div className="legal-meta__item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
                <span>Dernière mise à jour : 18 Novembre 2025</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-grid">
            {/* Main Content */}
            <div className="legal-main">
              <div className="legal-section">
                <h2 className="legal-section__title">1. Acceptation des Conditions</h2>
                <p className="legal-section__text">
                  En accédant et en utilisant le site web de BuroTime, vous acceptez d'être lié 
                  par ces conditions générales d'utilisation. Si vous n'acceptez pas ces conditions, 
                  veuillez ne pas utiliser notre site.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">2. Définitions</h2>
                <ul className="legal-list">
                  <li><strong>"Nous", "Notre", "BuroTime"</strong> : désigne la société BuroTime, 
                  entreprise de mobilier de bureau basée en Algérie</li>
                  <li><strong>"Vous", "Utilisateur", "Client"</strong> : désigne toute personne 
                  accédant ou utilisant notre site</li>
                  <li><strong>"Produits"</strong> : désigne tous les articles de mobilier de bureau 
                  disponibles à la vente sur notre site</li>
                  <li><strong>"Services"</strong> : désigne tous les services proposés par BuroTime, 
                  y compris la vente, la livraison et l'installation</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">3. Utilisation du Site</h2>
                
                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">3.1 Compte Utilisateur</h3>
                  <p className="legal-section__text">
                    Pour passer commande, vous devez créer un compte. Vous êtes responsable de :
                  </p>
                  <ul className="legal-list">
                    <li>Fournir des informations exactes et à jour</li>
                    <li>Maintenir la confidentialité de vos identifiants</li>
                    <li>Toutes les activités effectuées sous votre compte</li>
                    <li>Nous informer immédiatement de toute utilisation non autorisée</li>
                  </ul>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">3.2 Utilisation Autorisée</h3>
                  <p className="legal-section__text">
                    Vous vous engagez à utiliser notre site uniquement à des fins légales et de 
                    manière à ne pas porter atteinte aux droits d'autrui.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">3.3 Utilisations Interdites</h3>
                  <ul className="legal-list">
                    <li>Tenter d'accéder aux systèmes de manière non autorisée</li>
                    <li>Utiliser des robots ou scripts automatisés</li>
                    <li>Publier du contenu illégal, offensant ou frauduleux</li>
                    <li>Copier ou utiliser notre contenu sans autorisation</li>
                    <li>Perturber le fonctionnement du site</li>
                  </ul>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">4. Commandes et Paiements</h2>
                
                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">4.1 Passation de Commande</h3>
                  <p className="legal-section__text">
                    Lorsque vous passez une commande, vous faites une offre d'achat. Nous nous 
                    réservons le droit d'accepter ou de refuser toute commande pour des raisons 
                    légitimes.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">4.2 Confirmation de Commande</h3>
                  <p className="legal-section__text">
                    Un email de confirmation vous sera envoyé une fois votre commande validée. 
                    Ce message confirmera les détails de votre achat.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">4.3 Prix et Disponibilité</h3>
                  <ul className="legal-list">
                    <li>Les prix sont indiqués en Dinars Algériens (DZD) TTC</li>
                    <li>Nous nous réservons le droit de modifier les prix à tout moment</li>
                    <li>Les prix applicables sont ceux affichés au moment de la commande</li>
                    <li>La disponibilité des produits est sous réserve de stocks</li>
                  </ul>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">4.4 Modes de Paiement</h3>
                  <p className="legal-section__text">
                    Nous acceptons les paiements par :
                  </p>
                  <ul className="legal-list">
                    <li>Paiement à la livraison (espèces)</li>
                    <li>Virement bancaire</li>
                    <li>Chèque (pour les clients professionnels)</li>
                  </ul>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">5. Livraison</h2>
                
                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">5.1 Zone de Livraison</h3>
                  <p className="legal-section__text">
                    Nous livrons dans toutes les wilayas d'Algérie. Les délais varient selon la 
                    destination.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">5.2 Délais de Livraison</h3>
                  <ul className="legal-list">
                    <li>Alger : 2-3 jours ouvrables</li>
                    <li>Grandes villes : 3-5 jours ouvrables</li>
                    <li>Autres wilayas : 5-7 jours ouvrables</li>
                  </ul>
                  <p className="legal-section__text">
                    Ces délais sont indicatifs et peuvent varier selon les conditions.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">5.3 Frais de Livraison</h3>
                  <p className="legal-section__text">
                    Les frais de livraison sont calculés en fonction de la destination et du poids 
                    de la commande. Ils sont affichés avant validation de la commande.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">5.4 Réception de la Commande</h3>
                  <ul className="legal-list">
                    <li>Vérifiez l'état des produits à la réception</li>
                    <li>Signalez immédiatement tout dommage visible</li>
                    <li>Refusez le colis si l'emballage est gravement endommagé</li>
                  </ul>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">6. Droit de Rétractation et Retours</h2>
                
                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">6.1 Délai de Rétractation</h3>
                  <p className="legal-section__text">
                    Vous disposez d'un délai de 14 jours à compter de la réception pour exercer 
                    votre droit de rétractation, sans avoir à justifier de motifs.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">6.2 Conditions de Retour</h3>
                  <ul className="legal-list">
                    <li>Le produit doit être dans son emballage d'origine</li>
                    <li>Le produit ne doit pas avoir été utilisé</li>
                    <li>Tous les accessoires doivent être présents</li>
                    <li>Contactez-nous avant de retourner un produit</li>
                  </ul>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">6.3 Produits Exclus</h3>
                  <p className="legal-section__text">
                    Les produits personnalisés ou fabriqués sur mesure ne sont pas éligibles au 
                    droit de rétractation.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">6.4 Remboursement</h3>
                  <p className="legal-section__text">
                    Le remboursement sera effectué dans un délai de 14 jours après réception du 
                    produit retourné, sous réserve de vérification de son état.
                  </p>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">7. Garanties</h2>
                
                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">7.1 Garantie Légale</h3>
                  <p className="legal-section__text">
                    Tous nos produits bénéficient de la garantie légale de conformité conformément 
                    à la législation algérienne.
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">7.2 Garantie Commerciale</h3>
                  <p className="legal-section__text">
                    Nous offrons une garantie commerciale de 5 ans sur tous nos produits (sauf 
                    accessoires et pièces d'usure).
                  </p>
                </div>

                <div className="legal-subsection">
                  <h3 className="legal-subsection__title">7.3 Exclusions de Garantie</h3>
                  <ul className="legal-list">
                    <li>Dommages causés par une mauvaise utilisation</li>
                    <li>Usure normale</li>
                    <li>Modifications non autorisées</li>
                    <li>Dommages causés par un accident</li>
                  </ul>
                </div>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">8. Propriété Intellectuelle</h2>
                <p className="legal-section__text">
                  Tout le contenu de ce site (textes, images, logos, vidéos) est protégé par les 
                  droits d'auteur et appartient à BuroTime. Toute reproduction sans autorisation 
                  est interdite.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">9. Protection des Données</h2>
                <p className="legal-section__text">
                  Vos données personnelles sont traitées conformément à notre{' '}
                  <Link to="/privacy" className="legal-link">politique de confidentialité</Link>. 
                  Nous nous engageons à protéger votre vie privée.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">10. Limitation de Responsabilité</h2>
                <p className="legal-section__text">
                  BuroTime ne pourra être tenu responsable :
                </p>
                <ul className="legal-list">
                  <li>Des dommages indirects résultant de l'utilisation de nos produits</li>
                  <li>Des interruptions du site pour maintenance</li>
                  <li>Des erreurs ou omissions dans le contenu du site</li>
                  <li>Des retards de livraison dus à des cas de force majeure</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">11. Force Majeure</h2>
                <p className="legal-section__text">
                  Nous ne serons pas tenus responsables de tout manquement à nos obligations en 
                  cas de force majeure (catastrophe naturelle, guerre, grève, etc.).
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">12. Modification des Conditions</h2>
                <p className="legal-section__text">
                  Nous nous réservons le droit de modifier ces conditions à tout moment. Les 
                  modifications prendront effet dès leur publication sur le site. Votre utilisation 
                  continue du site après modification vaut acceptation.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">13. Loi Applicable et Juridiction</h2>
                <p className="legal-section__text">
                  Ces conditions sont régies par la loi algérienne. En cas de litige, les tribunaux 
                  d'Alger seront seuls compétents, sauf disposition légale contraire.
                </p>
              </div>

              <div className="legal-section">
                <h2 className="legal-section__title">14. Contact</h2>
                <p className="legal-section__text">
                  Pour toute question concernant ces conditions générales :
                </p>
                <div className="legal-contact-info">
                  <p><strong>Email :</strong> contact@burotime-dz.com</p>
                  <p><strong>Téléphone :</strong> +213 560 60 56 55</p>
                  <p><strong>Téléphone :</strong> +213 560 39 42 54</p>
                  <p><strong>Adresse :</strong> Ouled Fayet, Alger, Algérie</p>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <aside className="legal-sidebar">
              <div className="legal-sidebar__card">
                <h3 className="legal-sidebar__title">Navigation Rapide</h3>
                <nav className="legal-sidebar__nav">
                  <a href="#" className="legal-sidebar__link">Acceptation</a>
                  <a href="#" className="legal-sidebar__link">Utilisation du Site</a>
                  <a href="#" className="legal-sidebar__link">Commandes</a>
                  <a href="#" className="legal-sidebar__link">Livraison</a>
                  <a href="#" className="legal-sidebar__link">Retours</a>
                  <a href="#" className="legal-sidebar__link">Garanties</a>
                  <a href="#" className="legal-sidebar__link">Responsabilité</a>
                  <a href="#" className="legal-sidebar__link">Contact</a>
                </nav>
              </div>

              <div className="legal-sidebar__card">
                <h3 className="legal-sidebar__title">Documents Connexes</h3>
                <div className="legal-sidebar__links">
                  <Link to="/privacy" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                    Politique de Confidentialité
                  </Link>
                  <Link to="/cookies" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                      <polyline points="14 2 14 8 20 8"/>
                    </svg>
                    Politique de Cookies
                  </Link>
                  <Link to="/faq" className="legal-sidebar__doc-link">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
                      <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                    Questions Fréquentes
                  </Link>
                </div>
              </div>

              <div className="legal-sidebar__card legal-sidebar__card--highlight">
                <div className="legal-sidebar__icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
                  </svg>
                </div>
                <h3 className="legal-sidebar__title">Des Questions?</h3>
                <p className="legal-sidebar__text">
                  Notre équipe est là pour vous aider à comprendre vos droits.
                </p>
                <Link to="/contact" className="legal-sidebar__btn">
                  Nous Contacter
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsConditions;